import { useContext } from "react";
import MainContext from "../../../../Context/MainContext/MainContext";
import Permission from "../../../../Utility/Crud/Permission";
import Card from "../../../Card";
import MUIBox from "@mui/material/Box";
import MUITable from "@mui/material/Table";
import MUITableBody from "@mui/material/TableBody";
import MUITableCell from "@mui/material/TableCell";
import MUITableContainer from "@mui/material/TableContainer";
import MUITableHead from "@mui/material/TableHead";
import MUITableRow from "@mui/material/TableRow";
import MUICheckbox from "@mui/material/Checkbox";
import MUIPaper from "@mui/material/Paper";

export default function CardAdminRolePermissions(props) {
    const context = useContext(MainContext);

    const permissions = Permission.sort(
        context.permissionsIndexed ? Object.values(context.permissionsIndexed) : []
    );
    const selectedPermissionIdsSet = new Set((props.selectedPermissionIds || []).map((permissionId) => String(permissionId)));

    const handleTogglePermission = (permissionId, checked) => {
        const nextSelectedPermissionIdsSet = new Set(selectedPermissionIdsSet);
        if (checked) {
            nextSelectedPermissionIdsSet.add(String(permissionId));
        } else {
            nextSelectedPermissionIdsSet.delete(String(permissionId));
        }

        const nextSelectedPermissionIds = Array.from(nextSelectedPermissionIdsSet).map((id) => +id);
        props.onChange(nextSelectedPermissionIds);
    };

    const renderContent = () => (
        <MUIBox sx={{ overflowX: "auto" }}>
            <MUITableContainer component={MUIPaper} elevation={0}>
                <MUITable size="small">
                    <MUITableHead sx={{ backgroundColor: (theme) => theme.palette.background.default }}>
                            <MUITableRow>
                                <MUITableCell padding="checkbox" sx={{ width: 56 }}>
                                </MUITableCell>
                                <MUITableCell sx={{ width: "35%" }}>Name</MUITableCell>
                                <MUITableCell>Description</MUITableCell>
                            </MUITableRow>
                    </MUITableHead>
                    <MUITableBody>
                        {permissions.map((permission) => (
                            <MUITableRow
                                key={permission.id}
                                hover={true}
                                onClick={() => handleTogglePermission(permission.id, !selectedPermissionIdsSet.has(String(permission.id)))}
                                sx={{ cursor: "pointer" }}
                            >
                                <MUITableCell padding="checkbox">
                                    <MUICheckbox
                                        size="small"
                                        checked={selectedPermissionIdsSet.has(String(permission.id))}
                                        onChange={() => {}}
                                    />
                                </MUITableCell>
                                <MUITableCell>{permission.name ?? ""}</MUITableCell>
                                <MUITableCell>{permission.description ?? ""}</MUITableCell>
                            </MUITableRow>
                        ))}
                    </MUITableBody>
                </MUITable>
            </MUITableContainer>
        </MUIBox>
    );

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => "Permissions"}
        />
    );
}
